import CompliancyDisclaimer from './CompliancyDisclaimer';
export default CompliancyDisclaimer;

export { LoginRequired, TermsOfUseRequired } from './CompliancyDisclaimer';